module.exports = __webpack_public_path__ + "img/participant-edge.08570274.png";